import React from "react"
import "./Button.scss"
import PropTypes from "prop-types"
import { CheckValue } from "../../../services/CommonFunction"
import { selectIcon, SVG } from "../../UI/selector"

const Button = ({ className, icon, type, text, disabled, onClick }) => {
  let classNames = ["buttonClass"]
  if (CheckValue(className)) {
    classNames.push(className)
  }
  if (disabled) {
    classNames.push("disabledButton")
  }
  const classes = classNames.join().replace(/,/g, " ")
  return (
    <button type={type} className={classes} onClick={onClick}>
      {CheckValue(icon) ? <SVG src={selectIcon(icon)} /> : null} {text}
    </button>
  )
}

export default Button

Button.propTypes = {
  className: PropTypes.string.isRequired,
  icon: PropTypes.string,
  type: PropTypes.string,
  text: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  className: null,
  icon: null,
  type: "button",
  text: "click",
  disabled: false,
}
